(function () {
  'use strict';

  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const splitWords = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const texts = [];
    for (let n = walker.nextNode(); n; n = walker.nextNode()) texts.push(n);

    let index = 0;
    for (const node of texts) {
      const frag = document.createDocumentFragment();
      for (const part of node.nodeValue.split(/(\s+)/)) {
        if (!part) continue;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); continue; }
        const span = document.createElement('span');
        span.className = 'word';
        span.style.setProperty('--word-index', String(index++));
        span.textContent = part;
        frag.appendChild(span);
      }
      node.parentNode.replaceChild(frag, node);
    }
    return index;
  };

  const targets = document.querySelectorAll('[data-animate="words"]');
  targets.forEach((el) => {
    if (reduced) return;
    el.classList.add('split-words');
    if (splitWords(el) > 0) el.classList.add('is-split');
  });

  const watched = document.querySelectorAll('.split-words, .fade-up, .shimmer');
  if (!watched.length) return;

  if (reduced || !('IntersectionObserver' in window)) {
    watched.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  watched.forEach((el) => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
    else observer.observe(el);
  });
})();
